import { BlogPost } from '@adapters/prismic/types/blogPost';
import linkResolver from '@adapters/prismic/utils/linkResolver';
import { useLink } from '@hooks/useLink';
import Heading from '@components/ui/Heading';
import Button from '@components/ui/Button';
import CardLinkGrid from '@components/cms/CardLinkGrid';
import CardLink from '@components/cms/CardLink';

import styles from './BlogArticlesGrid.module.scss';

export interface BlogArticlesGridProps {
  blogPosts?: BlogPost[];
  title: string;
  linkTitle: string;
}

const BlogArticlesGrid = ({
  blogPosts,
  title,
  linkTitle,
}: BlogArticlesGridProps) => {
  const resolveLink = useLink();

  return (
    <section className={styles.container}>
      {!!title && (
        <Heading semanticLevel="h2" styleLevel="2" className={styles.heading}>
          {title}
        </Heading>
      )}

      {!!blogPosts && (
        <CardLinkGrid classNames={styles.cardLinkGrid}>
          {blogPosts.map((blogPost) => (
            <CardLink
              key={`recent-article-${blogPost.id}`}
              link={linkResolver(blogPost)}
              imageUrl={blogPost.data?.hero_image?.url}
              imageAlt={blogPost.data?.hero_image?.alt}
              date={blogPost.data?.formattedDate}
              title={blogPost.data?.title}
              excerpt={blogPost.data?.excerpt}
            />
          ))}
        </CardLinkGrid>
      )}

      {!!linkTitle && (
        <div className={styles.buttonContainer}>
          <Button
            variant="primary"
            size="large"
            href={resolveLink('blogHome')}
            label={linkTitle}
          />
        </div>
      )}
    </section>
  );
};

export default BlogArticlesGrid;
